<template>
  <div class="my-certificate">
    <div class="certificate-title">
      | 我的气象证明
    </div>
    <div class="certificate-list">
      <div v-if="noData" class="no-data">
        <img src="/static/image/weatherCertificate/no_data.png" />
        <div>暂无证明~</div>
      </div>
      <div v-else>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div v-for="item in list" :key="item.id" class="list-item" @click="click(item)">
            <div class="title">
              <span class="name">{{ item.name }}</span>
              <span :class="['status', 'status-' + item.status]">{{ item.status | getStatus }}</span>
            </div>
            <van-divider :style="{ padding: '0 5px', margin: '3px' }"></van-divider>

            <div class="conent">
              <div style="margin-top: 6px;">
                <span class="label">申请用途:</span> {{ item.purpose }}
              </div>
              <div style="margin-top: 6px;">
                <span class="label">申请时间:</span> {{ item.create_time | timeFormat }}
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import request from '@/utils/request'
import moment from 'moment'
export default Vue.extend({
  components: {
  },
  data() {
    return {
      list: [],
      pageNum: 0,
      pageSize: 10,
      noData: false,
      loading: false,
      finished: false,
      openId:''
    }
  },
  filters: {
    timeFormat(value) {
      const result = moment(value).format('YYYY-MM-DD HH:mm:ss') // 转换时间格式
      return result
    },
    getStatus(status) {
      let statusLabel = '待审核'

      if (status === '0') {
        statusLabel = '待审核'
      } else if (status === '1') {
        statusLabel = '审核通过'
      } else if (status === '2') {
        statusLabel = '审核未通过'
      }
      return statusLabel
    },
  },
  mounted() {
    this.openId = this.$store.state.openId
    console.log( this.openId)
    this.getData()
  },
  methods: {
    getData() {
      const { pageNum, pageSize } = this
      let params = {
        pageNum, pageSize,
        'open_id': this.openId
      }
      request.get('/cert/weather_cert/page', params).then((data) => {
        this.loading = false
        if (data.total === 0) {
          this.noData = true
          this.finished = true
        }
        if (data.list) {
          this.list = this.list.concat(data.list)
          this.pageNum++
          if (data.list.length === 0) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      })
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getData()
        this.loading = true
      }, 1000);
    },

    click(item) {
      console.log(item.status)
      if(item.status === '0'){
        this.$router.push('/weather_certificate/apply_result')
      }else{
       this.$router.push(`weather_certificate/apply_details/${item.id}`)
      }
    }
  },
})

</script>
<style scoped lang="scss">
.my-certificate {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px;
}

.certificate-title {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  background: linear-gradient(149deg, #0081E9 0%, #00D4FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.no-data {
  width: 100vw;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #BBBBBB;
  line-height: 20px;
}

.certificate-list {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.list-item {
  width: 90vw;
  height: 108px;
  box-shadow: 0px 0px 10px 0px rgba(0, 134, 234, 0.1);
  border-radius: 10px;
  margin-top: 10px;

  .title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    margin: 0 14px;
    line-height: 17px;

    .name {
      font-size: 14px;
      color: #333333;
    }

    .status {
      margin-right: 14px;
      float: right;
      font-size: 12px;
    }

    .status-0 {
      color: #0082E9;
    }

    .status-1 {
      color: #21CC64;
      ;
    }

    .status-2 {
      color: #E95600;
      ;
    }
  }

  .conent {
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    color: #333330;
    align-items: center;
    margin: 10px 14px;

    .label {
      padding-top: 3px;
      color: #BBBBBB;
    }
  }

}
</style>
